import { IUnitClient } from './client';
import ITeam from './teams';

export default interface IDoctor {
  id: string;
  nome: string;
  crm: string;
  email: string;
  crmUF: string;
  telefone?: string;
  celular?: string;
  unidadesCliente: IUnitClient[];
  cfm?: ICfm;
  times?: ITeam[];
  ativo?: boolean;
  motivoInativacao: string;
}

export interface ICfm {
  nome: string;
  situacao: string;
  liberado: boolean;
  tipoInscricao: string;
  dataAtualizacaoCfm: string;
  ultimaIntegracao: string;
  idMedico?: Number;
}

export class MedicoParmDTO {
  crm: string;
  crmUF: string;
  idsUnidadesClientes: Number[];
  ativo: boolean;
  motivoInativacao: string;
  nome: string;
}
